import React, { useState, useEffect } from "react";
import { Stack, Container } from "@mui/material";
import Api from "../../network/Api";
import Typewriter from 'typewriter-effect';
import SendButton from "../Conversations/SendButton";

const NewLesson = (props: { onConversationCreate: (conversationId: string, prompt: string) => void }) => {

  const [prompt, setPrompt] = useState<string>("");
  const [isAsking, shouldAsk] = useState<boolean>(false);

  useEffect(() => {
    if (!isAsking) { return }
    Api.post("/conversations", {}).then(result => {
      props.onConversationCreate(result.id, prompt)
    });
  }, [isAsking]);

  return (
    <Stack
      className="animate__animated animate__fadeIn"
      marginY="auto"
      width="100%"
    >
      <Container maxWidth="md">

        <h2 className='animate__animated animate__fadeInDown'>Describe a specific problem or lesson learned</h2>
        <h3 className="text-light text-info" style={{marginBottom: "2rem"}}>
          e.g. <Typewriter
            options={{
              strings: [
                'Project scopes often expand without control, causing costly rework',
                'Stakeholders are frequently misaligned, delaying project decisions',
                'Large, infrequent releases increase delivery risks',
                'Key decisions are poorly documented, slowing future projects',
                'Lack of transparency erodes trust between teams and stakeholders',
                'User feedback arrives too late, leading to wasted features',
                'Risks are assessed only once, missing emerging threats',
                'Dependencies lack clear ownership, causing delivery bottlenecks',
                'Test plans remain static and fail to adapt to project changes',
                'Team achievements go unrecognized, reducing morale and retention',
              ],
              autoStart: true,
              loop: true,
              delay: 0.5
            }}
          />
        </h3>

        <SendButton value={prompt}
                    disabled={isAsking}
                    isRunning={isAsking}
                    onChange={setPrompt}
                    onClick={() => shouldAsk(true)} />
        
      </Container>
    </Stack>
  );
};

export default NewLesson;
